import type { CSSProperties } from "react";
import { useEffect, useRef, useState } from "react";

import { cn } from "@/lib/utils";
import type { ResolvedFeaturePageVisual } from "@garimpa/api/featurePages/types";
import { defaultIfUndefined } from "@garimpa/lib/defaultIfUndefined";

export function FeaturePageVisual({
  visual,
  className,
  decorative = false,
  priority = false,
  sizes,
  style,
}: {
  visual: ResolvedFeaturePageVisual;
  className?: string;
  decorative?: boolean;
  priority?: boolean;
  sizes?: string;
  style?: CSSProperties;
}) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  useEffect(() => {
    const image = imageRef.current;
    if (image?.complete && image.naturalWidth === 0) setFailedUrl(visual.url);
  }, [visual.url]);

  if (failedUrl === visual.url) return null;

  return (
    <img
      ref={imageRef}
      src={visual.url}
      srcSet={visual.srcSet}
      sizes={defaultIfUndefined(sizes, visual.sizes)}
      width={visual.width ?? undefined}
      height={visual.height ?? undefined}
      alt={decorative ? "" : visual.alt}
      aria-hidden={decorative || undefined}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "low"}
      onError={() => setFailedUrl(visual.url)}
      className={cn("block", className)}
      style={style}
    />
  );
}
